module.exports = __webpack_public_path__ + "img/brand-bootstrap-vue.c755bfd7.svg";